export const getBracketsText = (value: string | number) => {
  return `(${value})`;
};
